import useCurrentExplorerItem from "@/common/hooks/useCurrentExplorerItem.ts";
import { ITrack } from "@/interfaces/ITrack.ts";

function useCurrentTrack(): ITrack | null {
  const explorerItem = useCurrentExplorerItem()

  const track = explorerItem?.track;

  return track || null
}

export default useCurrentTrack;
